import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import { addFeaturedGroup, getFeaturedGroups } from "../FeaturedGroupsService";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
}));
export default function AddFeaturedGroupModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [groupName, setGroupName] = useState("");
  const [processing, setProcessing] = useState(false);

  function addGroup() {
    let json = {
      ClientId: client.id,
      Name: groupName,
    };

    callAPI(
      addFeaturedGroup(json),
      "Group Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedGroups(client.id).then((response) => {
        response.forEach(
          (row) => (row.featureAdsLength = row.featureAds.length)
        );
        setTableData(response);
        openModal(false);
      });
    });
  }

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Featured Group
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Add Group Name"
                  label="Add Group Name"
                  variant="standard"
                  fullWidth
                  required
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                />
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addGroup()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
